import { atom } from 'recoil';

export const authModalDrawerController = atom<{
  login: boolean;
  signUp: boolean;
}>({
  key: 'authModalDrawerController',
  default: { login: false, signUp: false },
});
